<template>
    <div class="container-fluid ">
        <div class="row">
            <div class="col-12">
                <div class="form-floating">
                    <input id="inputName" type="text" name="name" class="form-control"  v-model="username_delete" @keyup.enter="submitForm" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("username_delete") }}</label>
                </div>
            </div>
        </div>
        <div class="text-danger" v-if="errors.length">
            <p v-for="error in errors" v-bind:key="error">{{ error }}</p>
        </div>
        <button class="btn btn-danger mt-2 mb-0 ms-auto" :disabled="isDemoUser" @click="submitForm">{{ $t("delete") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import apiClient from '@/services/apiClient'
export default {
    name: 'DeleteUser',
    emits: ['closeModal'],
    props: {
        user: {
            type: Object,
            required: true,
        },
        isDemoUser: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            username_delete:'',
            errors: []
        }
    },

    methods: {
        submitForm() {
            console.log('entry submitForm')
            this.errors = []

            console.log(this.user.username)
            console.log(this.username_delete)
            
            if(this.user.username != this.username_delete){
                this.errors.push(this.$t("user wrong"))
                return
            }
            apiClient
                .delete(`/api/v1/users/${this.user.id}`, this.user)
                .then(response => {

                    createToast({text: this.$t("user deleted")
                   ,type: 'success'})

                   this.$emit('closeModal', 'delete', response.data)
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
        }
    }
}
</script>